import { SvgIconType } from './svg.interface';

const Preview: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#A3ACBA'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 6C7.5 6.82843 6.82843 7.5 6 7.5C5.17157 7.5 4.5 6.82843 4.5 6C4.5 5.17157 5.17157 4.5 6 4.5C6.82843 4.5 7.5 5.17157 7.5 6Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 10.5C9.31371 10.5 12 6.98528 12 6C12 5.01472 9.31371 1.5 6 1.5C2.68629 1.5 0 5.01472 0 6C0 6.98528 2.68629 10.5 6 10.5ZM6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9Z"
      fill={color}
    />
  </svg>
);

export default Preview;
